import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  headerBox: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  avtarStyle: {
    height: "46px",
    width: "46px",
  },
  textHead: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  headerHeading: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#272525",
    height: "24px",
  },
  headerSubHeading: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#999999",
  },
}));

export default useStyle;
